import type { MeetingTime } from '@/app/types/interfaces';

const RECITATION_MODE = /^(recit|rec|recitation)$/i;

export function isRecitationMode(mode?: string | null): boolean {
  return RECITATION_MODE.test(mode?.trim() ?? '');
}

export function isRecitationMeeting(meeting: Pick<MeetingTime, 'mode'>): boolean {
  return isRecitationMode(meeting.mode);
}

export function hasRecitationMeeting(
  meetings: ReadonlyArray<Pick<MeetingTime, 'mode'>> | null | undefined,
): boolean {
  return meetings?.some(isRecitationMeeting) ?? false;
}

export function meetingTypeLabel(mode?: string | null): string | null {
  const normalized = mode?.trim();
  if (!normalized || /^(tba|unknown|in person)$/i.test(normalized)) return null;
  if (isRecitationMode(normalized)) return 'Recitation';
  if (/^lec(ture)?$/i.test(normalized)) return 'Lecture';
  if (/^lab(oratory)?$/i.test(normalized)) return 'Lab';
  if (/^sem(inar)?$/i.test(normalized)) return 'Seminar';
  return normalized;
}
